// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

export type Country = { code: string; name: string };

/**
 * Countries offered in the golf-course-admin "Find OSM golf courses" dropdown. ISO 3166-1
 * alpha-2 codes, matching what OverpassQueryBuilder.GolfCoursesInCountry expects server-side.
 * Not i18n'd — this is an admin-only tool, same treatment as the OSM place names it imports.
 */
export const COURSE_ADMIN_COUNTRIES: Country[] = [
  { code: 'SE', name: 'Sweden' },
  { code: 'DK', name: 'Denmark' },
  { code: 'NO', name: 'Norway' },
  { code: 'FI', name: 'Finland' },
  { code: 'DE', name: 'Germany' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'ES', name: 'Spain' },
  { code: 'FR', name: 'France' },
  { code: 'PT', name: 'Portugal' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'US', name: 'United States' },
];

export const DEFAULT_COURSE_ADMIN_COUNTRY_CODE = 'SE';
